import {cn} from 'cn';
import {flowRowClassName} from '../format-money';
import {FlowAmount} from './flow-amount';

type FlowLineProps = {
	label: string;
	value: number | null;
	unitValue: number | null;
	showPerUnit?: boolean;
	asExpense?: boolean;
	total?: boolean;
	emphasis?: boolean;
	percent?: boolean;
	onLabelClick?: () => void;
};

export function FlowLine({
	label,
	value,
	unitValue,
	showPerUnit = true,
	asExpense = false,
	total = false,
	emphasis = false,
	percent = false,
	onLabelClick,
}: FlowLineProps) {
	const labelClassName = cn(
		'min-w-0 flex-1 text-left',
		emphasis || total ? 'text-base font-bold' : 'text-[15px]',
		onLabelClick && 'underline decoration-dotted underline-offset-4',
	);

	return (
		<div className={cn(flowRowClassName(total), 'w-full')}>
			{onLabelClick ? (
				<button type="button" className={labelClassName} onClick={onLabelClick}>
					{label}
				</button>
			) : (
				<span className={labelClassName}>{label}</span>
			)}
			{showPerUnit ? (
				<FlowAmount
					value={unitValue}
					asExpense={asExpense}
					percent={percent}
					emphasis={emphasis}
					total={total}
				/>
			) : null}
			<FlowAmount
				value={value}
				asExpense={asExpense}
				percent={percent}
				emphasis={emphasis}
				total={total}
			/>
		</div>
	);
}
